<script setup lang="ts">
import type AlgoliaData from "~/types/AlgoliaData";

const props = defineProps({
    result: {
        type: Object as AlgoliaData | any,
        required: true,
    },
});

const route = useRoute();

const metaCurrentPage = computed(() => {
    return props.result?.meta?.current_page ?? props.result.page + 1 ?? 1;
});
const metaTotalPage = computed(() => {
    return props.result?.meta
        ? Math.ceil(props.result.meta.total / props.result.meta.per_page)
        : (props.result.nbPages ?? 1);
});

const pageBaseURL = route?.fullPath.includes("page") ? route?.fullPath.split("/page/")[0] : "articles";
const pageURL = `${pageBaseURL}/page/`;

const linkPrev = computed(() => {
    const queryAry = [] as string[];
    for (const [key, value] of Object.entries(route.query)) {
        queryAry.push(`${key}=${value}`);
    }

    // Statamic pagination
    if (props.result && props.result?.links?.prev) {
        const urlParams = new URLSearchParams(props.result.links.prev);
        return pageURL + urlParams.get("page") + "?" + queryAry.join("&");
    }

    // Algolia pagination
    if (props.result && props.result?.page) {
        return pageURL + props.result.page + "?" + queryAry.join("&");
    }
    return "";
});
const linkNext = computed(() => {
    const queryAry = [] as string[];
    for (const [key, value] of Object.entries(route.query)) {
        queryAry.push(`${key}=${value}`);
    }

    // Statamic pagination
    if (props.result && props.result?.links?.next) {
        const urlParams = new URLSearchParams(props.result.links.next);
        return pageURL + urlParams.get("page") + "?" + queryAry.join("&");
    }

    // Algolia pagination
    const nextPage = props.result ? props.result.page + 2 : 1;
    if (nextPage <= props.result.nbPages) {
        return pageURL + nextPage + "?" + queryAry.join("&");
    }
    return "";
});
</script>

<template>
    <div v-if="metaTotalPage > 1" class="mt-14 text-center md:text-right">
        <NuxtLink :to="linkPrev">
            <div
                class="-mb-2 inline-block rounded-full border bg-white px-3 py-2 shadow-lg"
                :class="linkPrev ? 'cursor-pointer' : ''"
            >
                <img
                    :src="linkPrev ? '/images/fa/chevron-left-regular.svg' : '/images/fa/chevron-left-duotone.svg'"
                    class="w-2"
                />
            </div>
        </NuxtLink>
        <div class="inline-block px-4">Page {{ metaCurrentPage }} of {{ metaTotalPage }}</div>
        <NuxtLink :to="linkNext">
            <div
                class="-mb-2 inline-block rounded-full border bg-white px-3 py-2 shadow-lg"
                :class="linkNext ? 'cursor-pointer' : ''"
            >
                <img
                    :src="linkNext ? '/images/fa/chevron-right-regular.svg' : '/images/fa/chevron-right-duotone.svg'"
                    class="w-2"
                />
            </div>
        </NuxtLink>
    </div>
</template>
